<template>
	<div>
		<el-container>
			<el-header>
				<Header></Header>
			</el-header>
			<div style="width:98%;margin:0 auto;padding:0;padding: 0">
				 <Nav ref="navRef"></Nav>
			</div>
			<!--select-->
			<div class="select-block">
				<el-form :inline="true" class="demo-form-inline">
					<provCity :provCityId="provCityId" v-if="this.$store.state.Code === '11'"></provCity>
					<el-form-item>
						<el-select placeholder="请选择品目" v-model="pinmu" style="width: 160px" clearable>
							<!-- <el-option label="请选择" value=""></el-option> -->
							<el-option v-for="(item,index) in listThreeCategory" :label="item.dictName" :value="item.dictKey" :key="index">
							</el-option>
						</el-select>
					</el-form-item>
					
					<!--<el-form-item label="时间" style="padding-left: 10px">-->
					<!--<el-select v-model="valueYear"  placeholder="请选择" style="width: 100px">-->
					<!--<el-option label="请选择" value=""></el-option>-->
					<!--<el-option-->
					<!--v-for="item in year"-->
					<!--:label="item.year"-->
					<!--:key="item.id"-->
					<!--:value="item.id"-->
					<!--&gt;-->
					<!--</el-option>-->
					<!--</el-select>-->
					<!--</el-form-item>-->
					<el-form-item label="">
						<el-input v-model.trim="njFactoryCode" placeholder="请输入出厂编号" style="width: 160px" clearable></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model.trim="imei" placeholder="请输入监控编号" style="width: 160px" clearable></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model.trim="factoryName" placeholder="生产企业" style="width: 160px" clearable></el-input>
					</el-form-item>
					<el-form-item label="" style="padding-left: 10px">
						<el-select v-model="warningType" placeholder="预警类型" style="width: 160px" clearable>
							<el-option label="面积未达标" :value="1"></el-option>
							<el-option label="机具未上报" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
				<!--number-->
			</div>
			<!--table-->
			<el-main style="padding:0;margin-top: 10px">
				<el-table :data="tableData">
					<el-table-column prop="id" label="序号" width="100" type="index">
						<template slot-scope="scope">
							<span>{{ (currentPage-1)*checkcurrentPage+parseInt(scope.$index)+1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="city_name" label="市（州）" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="county_name" label="县（区）" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="name" label="机主" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="nj_name" label="农机名称" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="factoryName" label="生产企业" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="factory_code" label="出厂编号" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>

					<el-table-column prop="currentYearArea" label="当年运行面积（亩）" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column prop="rectify_area" label="累计运行面积（亩）" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>

					<!--<el-table-column prop="imei" label="监控编号" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>-->
					<el-table-column prop="imei" label="监控编号" :show-overflow-tooltip="true" popper-class="tips">
					</el-table-column>
					<el-table-column width="80" prop="address" label="操作">
						<template slot-scope="scope">
							<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div v-show="nodata" class="zanwu">暂无数据</div>
			</el-main>
			<div class="block">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="checkcurrentPage" layout="total, prev, pager, next, jumper" :total="total" v-if="tableData&&tableData[0]">
				</el-pagination>
			</div>
			<div v-if="isloading" class="">
				<div class="el-loading-spinner"><i class="el-icon-loading"></i>
					<p class="el-loading-text">加载中</p>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import Api from '../../Serves/net-api.js'
	import Http from '../../Serves/net-http.js'
	import provCity from "../Index/common/provCity";
	import Nav from "../../components/Subsidies/nav";
	import { mapState } from "vuex";

	export default {
		name: "WarningSubsidy",
		components: {
			provCity,
			Nav
		},
		data() {
			return {
				nodata: false,
				isloading: true,
				loading: false, //表格加载状态
				value: 1,
				total: 1,
				currentPage: 1,
				checkcurrentPage: 12,
				pageSize: '',
				provCityId: {
					cityCode: '',
					provCode: '',
					countyCode: ''
				}, //省市区组件id
				listThreeCategory: [],
				listWarnYear: {},
				id: '',
				name: '',
				formInline: {
					user: '',
					region: ''
				},
				token: '',
				options: [],
				value1: '',
				cityId: '',
				pinmu: '',
				year: [],
				valueYear: '',
				sheng: '',
				provId: '',
				countyId: '',
				njFactoryCode: '',
				factoryName: '',
				imei: '',
				tableData: [],
				status: false,
				_year: null,
				warningType: ''
			}
		},
		computed: {
			...mapState({
				result: state => state.result
			})
		},
		activated() {
    this.$refs.navRef.activeName='预警机具监管'
    },
		mounted() {
      sessionStorage.removeItem('manageParams1')
			this.navId = sessionStorage.getItem('navClickVal');
      if (this.$store.state.WarningData.length !== 0) {
        var data = this.$store.state.WarningData
        this.provCityId.provCode = data.provCode
        this.provCityId.cityCode = data.cityCode
        this.provCityId.countyCode = data.countyCode
        this.pinmu = data.pinmu
        this.warningType = data.warningType
        this.imei = data.imei
        this.currentPage = data.currentPage
        this.checkcurrentPage = data.pageSize
        this.njFactoryCode = data.njFactoryCode
        this.factoryName = data.factoryName
        this.query()
        this.getlistThreeCategory()
      } else {
        this.getlistThreeCategory()
        this.query()
      }
		},
		methods: {
			// 获取列表数据
			query() {
				var onsearch = {
					provCode: this.provCityId.provCode,
					cityCode: this.provCityId.cityCode,
					countyCode: this.provCityId.countyCode,
					pinmu: this.pinmu,
					//year: this._year,
					// year:this.year.toString(),
					njFactoryCode: this.njFactoryCode,
					factoryName: this.factoryName,
					imei: this.imei,
					warningType: this.warningType,
					currentPage: this.currentPage,
					pageSize: this.checkcurrentPage
				}
        this.loading = true
        this.isloading = true
				var url = Http.test + '/applicationSubsidy/warningMachineList'
				Api.doPost(url, onsearch, false, (res) => {
					this.isloading = false
					this.tableData = res.result.dataSource
					this.total = res.result.totalRow
					if(this.tableData.length == 0) {
						this.nodata = true
					} else {
						this.nodata = false
					}
				}, (doError) => {
					console.log(doError)
				})
			},
			onSubmit() {
				if(this.valueYear !== '') {
					this._year = this.year[this.valueYear].year
				}
				this.currentPage = 1
				this.nodata = false
				this.isloading = true
				this.query()
			},
			//品目
			getlistThreeCategory() {
				// var url=Http.test+'/common/listThreeCategory'
				// var url=Http.test+'/dtIotNjData/getItemsByType'
				var url = Http.test + '/sysDict/getItemsByType'
				var parmse = {
					// areaCode:this.result.areaCode,
					// level:this.result.areaLevel,
					// year: new Date().getFullYear()
				}
				Api.doPost(url, parmse, false, (res) => {
					this.listThreeCategory = res.result
					// res.result.forEach(item => {
					//   if (item) {
					//     this.listThreeCategory.push(item)
					//   }
					// })
				}, (doError) => {
					console.log(doError)
				})
			},
			//年
			getyear() {
				//有数据不在请求
				// if(this.year.length>0){
				//   return false;
				// }
				var url = Http.test + '/warn/listWarnYear'
				var parmse = {}
				Api.doPost(url, parmse, true, (res) => {
					this.year = res.result.listWarnYear.map((e, i) => {
						e.id = i
						return e
					})
				}, (doError) => {
					console.log(doError)
				})
			},
			handleClick(row) {
        var data = {
          provCode:this.provCityId.provCode,
          cityCode:this.provCityId.cityCode,
          countyCode:this.provCityId.countyCode,
          imei: this.imei,
          pinmu: this.pinmu,
          currentPage: this.currentPage,
          pageSize: this.checkcurrentPage,
          njFactoryCode: this.njFactoryCode,
          factoryName: this.factoryName,
          warningType: this.warningType
        }
        this.$store.commit('WarningData', data);
				this.$router.push({
					name: 'SubsidyDetails',
					query: {
						imei: row.imei,
						njId: row.id,
            qrNumber: row.qrNumber
					}
				})
			},
			handleSizeChange(val) {
				this.checkcurrentPage = val
				this.currentPage = 1
				this.query()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage
				this.query()
			}
		}
	}
</script>
<style scoped>
	.zanwu {
		text-align: center;
		font-size: 34px;
		color: #999;
		width: 100%;
		height: 600px;
		line-height: 600px;
	}
	
	.el-table {
		width: 98% !important;
		margin: auto;
		color: #fff;
	}
	
	.block {
		width: 100%;
		margin-top: 1vh;
		display: -webkit-box;
		-webkit-box-align: center;
		-webkit-box-pack: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.select-block {
		display: inline-block;
		padding: 0 20px;
		/*height: 40px;*/
		line-height: 40px;
		margin-top: 10px;
		width: 97%;
	}
	
	header {
		height: 0px !important;
	}
	
	form {
		display: inline-block;
	}
	
	.parameter {
		width: 100%;
		height: 85px;
		line-height: 85px;
		background: #101c4a;
		margin-bottom: 10px;
	}
	
	.parameter>div {
		margin-left: 30px;
		margin-top: 30px;
		color: #75c3ff;
	}
	
	.parameter>div div {
		display: inline-block;
	}
	
	.parameter div span {
		display: inline-block;
		line-height: 40px;
	}
	
	.parameter>div div span:nth-child(2) {
		font-size: x-large;
		font-weight: bold;
		color: #fff;
		position: relative;
		top: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/TableList/WarningSubsidy.vue